import {
	Subscriber,
	SystemEntitySubscriber,
} from 'domain/subscription/interfaces/Subscription';
import {
	HStack,
	Link,
	Text,
	VStack,
} from '@montel/montelpro-shared-components-v2';
import { LabelAndValue } from 'components/common/LabelAndValue/LabelAndValue';
import { styled } from 'styled-components';

export const SubscriberList: React.FunctionComponent<{
	accountSubscribers: Subscriber[];
	systemEntitySubscribers: SystemEntitySubscriber[];
}> = ({ accountSubscribers, systemEntitySubscribers }) => {
	const hasAccountSubscribers = !!accountSubscribers.length;
	const hasSystemEntitySubscribers = !!systemEntitySubscribers?.length;
	const hasSubscribers = hasAccountSubscribers || hasSystemEntitySubscribers;

	if (!hasSubscribers)
		return <Text>This subscription has no subscribers.</Text>;

	const firstFiveAccountSubscribers = accountSubscribers.slice(0, 5);
	const firstFiveSystemEntitySubscribers =
		systemEntitySubscribers?.slice(0, 5) || [];

	return (
		<VStack fullWidth gap="lg">
			{hasSystemEntitySubscribers && (
				<>
					<Text size={'xs'} color={'textSubtle'}>
						System Entity Subscribers
					</Text>
					<LabelAndValue
						minWidth="100px"
						label="Name"
						value={
							<VStack>
								{firstFiveSystemEntitySubscribers.map(
									(subscriber) => (
										<StyledLink
											key={subscriber.id}
											href={`/systementities/${subscriber.id}`}
										>
											{subscriber.displayName}
										</StyledLink>
									),
								)}
							</VStack>
						}
					/>
					{systemEntitySubscribers.length > 5 && (
						<Text size="sm" color="textSubtle">
							...and{' '}
							<WhiteText>
								{systemEntitySubscribers.length - 5}
							</WhiteText>{' '}
							more
						</Text>
					)}
				</>
			)}
			{hasAccountSubscribers && (
				<>
					<Text size={'xs'} color={'textSubtle'}>
						Account Subscribers
					</Text>
					<HStack gap="lg">
						<LabelAndValue
							minWidth="100px"
							label="Name"
							value={
								<VStack>
									{firstFiveAccountSubscribers.map(
										(subscriber) => (
											<StyledLink
												key={subscriber.id}
												href={`/accounts/users/${subscriber.id}`}
											>
												{subscriber.name}
											</StyledLink>
										),
									)}
								</VStack>
							}
						/>
						<LabelAndValue
							minWidth="100px"
							label="Email"
							value={
								<VStack>
									{firstFiveAccountSubscribers.map(
										(subscriber) => (
											<Text key={subscriber.id}>
												{subscriber.email}
											</Text>
										),
									)}
								</VStack>
							}
						/>
					</HStack>
					{accountSubscribers.length > 5 && (
						<Text size="sm" color="textSubtle">
							...and{' '}
							<WhiteText>
								{accountSubscribers.length - 5}
							</WhiteText>{' '}
							more
						</Text>
					)}
				</>
			)}
		</VStack>
	);
};

const WhiteText = styled.span`
	color: ${({ theme }) => theme.colors.textDefault};
`;

const StyledLink = styled(Link)`
	text-underline-offset: 4px;
`;
